import React, { Component } from "react"
import { Subscription } from "rxjs"
import CustomerNotificationsGet from "../../api/Notifications/CustomerNotificationsGet"
import CustomerNotifications from "../../api/Notifications/Model/CustomerNotifications"
import CustomerNotification from "../../api/Notifications/Model/CustomerNotification"
import { NotificationCard } from "./NotificationCard"

interface NotificationPanelState {
  loading: boolean
  notifications?: CustomerNotifications
  pinnedNotifications: CustomerNotification[]
  unpinnedNotifications: CustomerNotification[]
}

export class NotificationPanel extends Component<{}, NotificationPanelState> {
  state: NotificationPanelState = {
    loading: false,
    pinnedNotifications: [],
    unpinnedNotifications: []
  }

  subscriptions = new Subscription()

  componentDidMount() {
    this.setState({ loading: true })
    this.subscriptions.add(
      CustomerNotificationsGet().subscribe(
        results => {
          const pinnedNotifications = results.Records?.filter(record => record.Pinned)
          const unpinnedNotifications = results.Records?.filter(record => !record.Pinned)
          this.setState({ notifications: results, pinnedNotifications, unpinnedNotifications, loading: false })
        },
        () => this.setState({ loading: false })
      )
    )
  }

  componentWillUnmount(){
    this.subscriptions.unsubscribe()
  }

  render() {
    if (this.state.loading) {
      return <></>
    }
    return <div>
      {this.state.pinnedNotifications.map((row: CustomerNotification, i: number) =>
        <NotificationCard
          key={`pinned_note_${i}`}
          notification={row}
          index={i}
          count={this.state.pinnedNotifications.length}
        />)}
      {this.state.unpinnedNotifications.map((row: CustomerNotification, i: number) =>
        <NotificationCard
          key={`unpinned_note_${i}`}
          notification={row}
          index={i}
          count={this.state.unpinnedNotifications.length}
        />)}
    </div>
  }
}
